<template>
  <main class="main" role="main">
    <div class="main_con">
      <div class="empty_wrap">
        <div class="empty">
          <!--'기본: ', '준비중: ready', '결과없음: result'-->
          <div class="msg">
            <div>상담하시기 전에 요청서를 먼저 보내면</div>
            <div>더욱 편리한 상담이 가능합니다.</div>
            <br />
            <div>요청서를 작성하신 후 채팅 상담을 받아 보세요.</div>
            <button class="btn bo" @click="gotoEstimationPage">
              견적요청서 작성하러 가기
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimateTypes from '@common/store/modules/estimate/types';

export default {
  data() {
    return {};
  },
  created() {
    this.resetEstimationModel();
  },
  methods: {
    ...estimateMapActions([estimateTypes.ESTIMATION_MODEL_RESET_STATE]),
    resetEstimationModel() {
      this[estimateTypes.ESTIMATION_MODEL_RESET_STATE]();
    },
    gotoEstimationPage() {
      this.$router.push({ name: 'Estimation.Form' });
    },
  },
};
</script>
